import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Separator as ManorSeparator } from '@comparethemarketau/manor-separator';

const useStyles = createUseStyles((theme) => ({
    separator: {
        borderRight: `0.1rem solid ${theme.colors.grey300}`,
        borderBottom: `0.1rem solid ${theme.colors.grey300}`
    },
    vertical: {
        height: 'unset',
        alignSelf: 'stretch'
    },
    horizontal: {
        width: 'unset',
        alignSelf: 'stretch'
    }
}));

const Separator = ({ type, insideFlexbox, className }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const insideFlexboxClassName = insideFlexbox && (type === 'vertical' ? classes.vertical : classes.horizontal);
    return (
        <ManorSeparator type={type} noSpacing className={classNames(classes.separator, insideFlexboxClassName, className)} />
    );
};

Separator.propTypes = {
    type: PropTypes.oneOf(['vertical', 'horizontal']),
    insideFlexbox: PropTypes.bool,
    className: PropTypes.string
};

export { Separator };
